import React from "react"
import PubSub from "pubsub-js"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import { getValue, setValue } from "aldoo-ra/Value"

// Shared with invoice-step.jsx / aldoo-ra/Store/flows/purchase-flow.jsx
const INVOICE_FORM_KEY = "checkout-invoice-form-data"

/**
 * Sticky total bar for the payment steps.
 *
 * The invoice form is opened from here instead of being a mandatory step —
 * only buyers who actually need an invoice pay the extra screen.
 *
 * Overrides the aldoo-ra fragment for the project Typography variants.
 */
const CheckoutTotalBar = ({ store }) => {
  const texts = TextBundle({ id: "aldoo-store" })
  const { getCartTotalValue } = store

  const openInvoice = () => {
    // setValue writes synchronously, so the invoice step's skipCondition sees
    // the flag by the time PURCHASE_FLOW_GOTO is handled
    setValue(INVOICE_FORM_KEY, {
      ...(getValue(INVOICE_FORM_KEY) || {}),
      needsInvoice: true,
      showInvoiceForm: true,
    })

    PubSub.publish("PURCHASE_FLOW_GOTO", { stepId: "invoice" })
  }

  return (
    <div
      className="sticky bottom-0 left-0 right-0 w-full h-[50px] flex items-center justify-between gap-2 px-6 bg-paper border-t-2 border-gray-200 z-[50]"
      style={{ boxShadow: "0 -4px 6px -1px rgba(0, 0, 0, 0.1)" }}
    >
      <button
        type="button"
        onClick={openInvoice}
        className="text-sm text-primary underline underline-offset-2 hover:opacity-80 transition-opacity"
      >
        {texts?.needInvoice || "Need an invoice?"}
      </button>

      <div className="flex items-center gap-2">
        <Typography
          variant="txt"
          className="text-text"
        >
          {texts?.total || "Estimated Total"}:
        </Typography>

        <Typography variant="body1_accent">
          {getCartTotalValue()}
        </Typography>
      </div>
    </div>
  )
}

export default CheckoutTotalBar
